module.exports = __webpack_public_path__ + "static/img/xyg.ae7eff35.png";